import { resultsFiltersReducerKey } from './ResultsFiltersConstants';

export function resultsFiltersState(state) {
  return state.get(resultsFiltersReducerKey);
}

export function open(state) {
  return resultsFiltersState(state).get('open');
}
